import SkeletonBox from '@/components/atoms/SkeletonBox/SkeletonBox';

import styles from './ActivityLogEntry.module.scss';

export default function ActivityLogEntrySkeleton() {
    return (
        <div className={styles.entry}>
            <div className={styles.titleRow}>
                <SkeletonBox width={180} height={16} />
                <SkeletonBox
                    width={80}
                    height={20}
                    borderRadius={999}
                    className={styles.actionBadge}
                />
            </div>
            <SkeletonBox width="75%" height={12} />
            <SkeletonBox width={120} height={10} />
            <SkeletonBox width={180} height={10} />
        </div>
    );
}
